import { call, put, takeLatest, takeEvery, delay, select } from 'redux-saga/effects';

import {
	getCompanies,
	getCompaniesSuccess,
	getCompaniesFailure,
	getCompanyById,
	getCompanyByIdFailure,
	getCompanyByIdSuccess,
	createCompany,
	createCompanyFailure,
	createCompanySuccess,
	updateCompany,
	updateCompanyFailure,
	updateCompanySuccess,
	removeCompany,
	removeCompanyFailure,
	removeCompanySuccess,
} from '.';

import companyService from '../../../services/CompanyService';

function* rootSaga() {
	yield takeLatest(getCompanies, getCompaniesSaga);
	yield takeLatest(getCompanyById, getCompanyByIdSaga);
	yield takeLatest(createCompany, createCompanySaga);
	yield takeLatest(updateCompany, updateCompanySaga);
	yield takeLatest(removeCompany, removeCompanySaga);
}

function* getCompaniesSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(companyService.getAll, payload);
		yield put(getCompaniesSuccess(response));
	} catch (error) {
		yield put(getCompaniesFailure(error));
	}
}

function* getCompanyByIdSaga({ payload }) {
	try {
		yield delay(300);
		const company = yield call(companyService.get, payload);
		yield put(getCompanyByIdSuccess(company));
	} catch (error) {
		yield put(getCompanyByIdFailure(error));
	}
}

function* createCompanySaga({ payload }) {
	try {
		yield delay(300);
		const createdCompany = yield call(companyService.create, payload);
		yield put(createCompanySuccess(createdCompany));
	} catch (error) {
		yield put(createCompanyFailure(error));
	}
}

function* updateCompanySaga({ payload }) {
	const { companyId: id, data: companyForm } = payload;
	try {
		yield delay(300);
		const updatedCompany = yield call(companyService.update, id, companyForm);
		yield put(updateCompanySuccess(updatedCompany));

		// Refresh company list after update:
		const tableParams = yield select(({ companies }) => companies.companies.tableParams);
		yield put(getCompanies({ ...tableParams }));
	} catch (error) {
		yield put(updateCompanyFailure(error));
	}
}

function* removeCompanySaga({ payload }) {
	const id = payload;
	try {
		yield delay(300);
		const removedCompany = yield call(companyService.remove, id);
		yield put(removeCompanySuccess(removedCompany));

		// Refresh company list after remove:
		const tableParams = yield select(({ companies }) => companies.companies.tableParams);
		yield put(getCompanies({ ...tableParams }));
	} catch (error) {
		yield put(removeCompanyFailure(error));
	}
}

export default rootSaga;
